module.exports = __webpack_public_path__ + "assets/media_primary.52337cd0.svg";